/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const recordWebVisitorV1ResponseDataSchema = z.object({
  recorded: z.boolean(),
});

export type IRecordWebVisitorV1ResponseData = z.infer<typeof recordWebVisitorV1ResponseDataSchema>;

export const recordWebVisitorV1ResponseSchema = createApiResponseSchema(
  recordWebVisitorV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IRecordWebVisitorV1ResponseData>>;

export type IRecordWebVisitorV1Response = IAPI<IRecordWebVisitorV1ResponseData>;
